module.exports = __webpack_public_path__ + "static/media/emptyimage.b6681619.png";